<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100 flying-body" src="../assets/cls_sideview.png"> -->

    <div class="flex col-12 justify-between">
      <img class="cbx-logo" src="../assets/CQL_logo_kombi.svg">
    </div>

    <div class="login-window max-width-3 box-shadow-big mx-auto bg-color-verylightgray rounded-border mb4">
      <div class="pt3 pr3 pl3 pb3">
        <div class="flex align-middle mb2">
        </div>
        <div class="flex mb3 pt2">
          <div id="sign-content" class="p max-width-2 mb4 mx-auto" style="line-height: 29px;">

              <div class="flex align-middle">
                <img class="cbx-logo mr2" style="width: 80px; height:140px;" src="../assets/cql_logo.svg">
                <h2 class="h3 color-lightblue regular mx-auto lh-2">{{$t('contract-sign_please_accept_contract')}}</h2>
              </div>

              <contract-text-de v-if="$i18n.locale == 'de'" />
              <contract-text-en v-if="$i18n.locale == 'en'" />


            
            
          </div>
        </div>
        <div class="mx-auto center">
        <router-link class="btn btn-small btn-bg-red" :to="'/' + this.$i18n.locale">{{$t('contract-sign_cancel')}}</router-link>
        <a class="btn btn-primary ml4" @click="saveContractSigning()">{{$t('contract-sign_accept_contract')}}</a>
        </div>
        
      </div>

     
    </div>
  </div>
</template>

<script>

import { EventBus } from "../event-bus";
import axios from 'axios';
import contract_text_de from './contract_text_de.vue' 
import contract_text_en from './contract_text_en.vue' 



export default {
  name: "ContractSign",
  data() {
    return {
      systemname: process.env.VUE_APP_SYSTEMNAME,


      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,


    };
  },
  created: function () {
   EventBus.$on('loginSuccessful', (payload) => {
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      // console.log('missing event!');
      this.userdata = payload.userdata;
      this.username = payload.userdata.company  + " " + payload.userdata.firstname + " " + payload.userdata.name;
      this.session = payload.session;
      this.loginStatus = true;
    });
  },
  mounted: function () {
    EventBus.$emit('loginCheckQaL', {
    });
  },
  components: {
    'contract-text-de': contract_text_de,
    'contract-text-en': contract_text_en
  },

  methods: {
    saveContractSigning(){

    let createURL =  process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/accept-cql-contract'

    let currentObj = this;

      axios.post(createURL, this.session)
      .then(response => {
        console.log(response)
        console.log('Contract accepted...')
        this.$router.push({ path:'/' + this.$i18n.locale + '/projects'});
      })
      .catch(function (error) {
        currentObj.log('catch Function of AJAX-Called... error()');
        currentObj.log(error);
      });


    
    // this.$router.push({ path:'/' + this.$i18n.locale + '/projects'});

    },

    log: function (obj) {
      if(this.debug) {
        console.log(obj)
      }
    },


  },

};
</script>
<style scoped>
</style>
